import {createDisplayImageField} from '../shared/createDisplayImageField';
import {
  BACKGROUND_IMAGE_FIELD,
  BACKGROUND_MENU_FIELD,
  createImageUploadSectionConfig
} from '../shared/displayImageFieldPresets';

export const FREEKICK_BACKGROUND_IMAGE_FIELDS = [
  BACKGROUND_MENU_FIELD,
  createDisplayImageField(
    'backgroundSelectTeam',
    'Background Select Team Image'
  ),
  BACKGROUND_IMAGE_FIELD,
  createDisplayImageField('backgroundNextLevel', 'Background Next Level')
];

export const FREEKICK_BACKGROUND_SECTION_CONFIG =
  createImageUploadSectionConfig({
    testId: 'background-images-section',
    downloadButtonIcon: 'leading'
  });
